import { PasswordData } from '../../models/agents/password';

export class AddPassword {
  readonly type = 'ADD_PASSWORD';
  constructor(public data: PasswordData) {}
}

export type Actions = AddPassword;
